const ABFieldTreeCore = require("../../core/dataFields/ABFieldTreeCore");
module.exports = class ABFieldTree extends ABFieldTreeCore {};
